<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <Table border :columns="tableColumns" :data="membersList">
              <template slot-scope="{ row }" slot="name">
                <strong>{{row.memberName}}</strong>
              </template>
              <template slot-scope="{ row }" slot="action">
                <ButtonGroup size="small">
                  <Button type="info" size="small" @click="show(row)">查看</Button>
                  <Button type="primary" size="small" @click="edit(row)">修改</Button>
                  <Button type="error" size="small" @click="newsRemoveNotice(row)">删除</Button>
                </ButtonGroup>
              </template>
            </Table>
            <div class="admin-list-pager">
              <Page :total="membersNum" show-elevator show-total @on-change="pageChaged" />
            </div>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
    <Modal v-model="showMmoda" width="360">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>删除确认</span>
      </p>
      <div style="text-align:center">
        <p>该内容删除后不能恢复。</p>
        <p>您确认要删除吗?</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long  @click="remove">删除</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  //数据
  data() { return {
    showMmoda: false,
    deleteMember: {},
    token: '',
    page: 1,
    status: 1,
    membersNum: 0,
    membersList: [],
    tableColumns: [
      {
        title: '姓名',
        slot: 'name',
        width: 126
      },
      {
        title: '性别',
        key: 'gender',
        width: 80,
        align: 'center'
      },
      {
        title: '职称',
        key: 'memberTitle',
        width: 126
      },
      {
        title: '电话',
        key: 'memberTel',
        width: 136
      },
      {
        title: '生日',
        key: 'birthday',
        width: 116
      },
      {
        title: '工作单位',
        key: 'workunit'
      },
      {
        title: '操作',
        slot: 'action',
        width: 170,
        align: 'center'
      }
    ],
  }},
  
  //加载后执行
  mounted() {
    //初始化页面数据
    this.initAuthData()

    //获取会员列表
    this.getMembersList()
  },
  
  //自定义函数
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //获取会员列表
    getMembersList() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/members/list-for-manage",
        {page: vm.page, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.membersList = info.data.list
        vm.membersNum = info.data.num
      }).catch(function(error) {
        console.log(error)
      });
    },

    //查看会员
    show (item) {
      window.open(this.$router.resolve({ path: '/manage/members/show', query: { id: item.memberId }}).href)
    },

    //会员修改
    edit(item) {
      window.open(this.$router.resolve({ path: '/manage/members/edit', query: { id: item.memberId }}).href)
    },

    //删除提示
    newsRemoveNotice(item) {
      this.deleteMember = item
      this.showMmoda = true
    },

    //会员删除
    remove () {
      let vm = this  
      let memberId = this.deleteMember.memberId
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/members/member-delete-by-id",
        {memberId: memberId, status: -1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        let error = parseInt(info.code)
        if(!isNaN(error) && error==0) {
          vm.getMembersList()
          vm.showMmoda = false
          vm.deleteNews = {}
        }
      }).catch(function(error) {
        console.log(error)
      });
    },

    //分页
    pageChaged(page) {
      this.page = page
      this.getMembersList()
    }

  }
}
</script>